import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaTag, FaGlobe, FaFileAlt, FaTwitter, FaCode } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation } from "swiper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apis from "../services";
import ReactLoading from "react-loading";
import DynamicHeader from "../Header/DynamicHeader";
import { ShowApiErrorToast } from "./ShowAPIErrors";
import { useErrorModal } from "../contexts/ErrorModalContext";

SwiperCore.use([Navigation]);

const DetailPS = () => {
  const { state } = useLocation();
  const [icoDetails, setIcoDetails] = useState(state?.apiData || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);
  const [type, setType] = useState(false);
  const [mainImageIndex, setMainImageIndex] = useState(0);

  const { showError } = useErrorModal();

  useEffect(() => {
    if (!state?.apiData) {
      setError("Invalid request. No coin data available.");
      setLoading(false);
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setIcoDetails(state.apiData);
      setIsFavorite(state.apiData.is_favourite === 1);
      setType(state.apiData?.type);
      setLoading(false);
    });
  }, [state]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#181A20]">
        <ReactLoading type="spin" color="#be6bed" height={50} width={50} />
      </div>
    );
  }
  if (error) return <div>{error}</div>;
  if (!icoDetails) return <div>No data available</div>;

  const { capsule, overview, rounds, images, links, Ticker } =
    icoDetails.tokenDetails.details;
  const { tokenName, category } = icoDetails.tokenDetails;

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setIsSliderOpen(true);
  };
  const closeSlider = () => setIsSliderOpen(false);

  const userId = localStorage.getItem("userId");
  const handleToggleFavorite = async () => {
    try {
      console.log(icoDetails.tokenDetails, "icoDetails.tokenDetails");
      const favoriteBody = {
        itemId: icoDetails.tokenDetails._id,
        type,
        userId,
      };
      const favoriteResponse = await apis.favourite(favoriteBody);

      favoriteResponse.success &&
        toast.success(
          favoriteResponse.message || "Action completed successfully."
        );

      setIsFavorite(favoriteResponse.isFavorite);

      if (type === "active") {
        const activeIdResponse = await apis.getactiveId(
          icoDetails.tokenDetails._id
        );
        setIcoDetails(activeIdResponse);
        setIsFavorite(activeIdResponse?.is_favourite === 1);
      } else {
        const upcResp = await apis.getupcomming(icoDetails.tokenDetails._id);
        setIcoDetails(upcResp);
        setIsFavorite(upcResp?.is_favourite === 1);
      }
    } catch (error) {
      showError(
        error?.response?.data?.message ||
          error?.message ||
          "You can add total 8 of this type of tokens in free plan. Please upgrade your plan to add more tokens to your watchlist."
      );
    }
  };

  return (
    <div className="detailps-bg">
      <ToastContainer />
      <div className="detailps-header">
        <DynamicHeader />
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="detailps-header-title">
              {tokenName || "Project Name"}
              {Ticker && (
                <span
                  style={{
                    color: "#be6bed",
                    fontWeight: 500,
                    fontSize: 18,
                    marginLeft: 10,
                  }}
                >
                  {Ticker}
                </span>
              )}
              {category && (
                <span className="detailps-header-badge">{category}</span>
              )}
            </div>
          </div>
          <div className="detailps-header-buttons">
            {links &&
              links.map((link, i) => {
                let Icon;
                if (link.name === "Website") Icon = FaGlobe;
                else if (link.name === "Whitepaper") Icon = FaFileAlt;
                else if (link.name === "Twitter") Icon = FaTwitter;
                else if (link.name === "Source") Icon = FaCode;
                return (
                  <a
                    key={i}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="detailps-btn">
                      {Icon && <Icon />} {link.name}
                    </button>
                  </a>
                );
              })}
          </div>
        </div>
      </div>

      <div className="detailps-main">
        {/* Images Area */}
        <div className="detailps-img-area">
          {images?.[2] && (
            <img
              src={images[2]}
              alt={tokenName || "Project"}
              onClick={() => handleImageClick(2)}
              className="detailps-img-main"
            />
          )}
          {images && images.length > 1 && (
            <div className="detailps-img-thumbs">
              {images.slice(1).map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`Preview ${i + 2}`}
                  onClick={() => handleImageClick(i + 1)}
                  className="detailps-img-thumb"
                />
              ))}
            </div>
          )}
        </div>

        {/* Overview Card */}
        <div className="detailps-overview-card">
          <div className="detailps-overview-header">
            <div
              style={{
                fontSize: "1.40rem",
                fontWeight: "bold",
                fontFamily: "a Atmospheric",
              }}
            >
              Overview
            </div>
            <button className="detailps-fav-btn" onClick={handleToggleFavorite}>
              <img
                src={isFavorite ? "/likered.svg" : "/unlike.svg"}
                alt={isFavorite ? "Unlike" : "Like"}
                style={{
                  width: "22px",
                  height: "22px",
                  marginLeft: "8px",
                  transition: "transform 0.3s ease",
                  transform: isFavorite ? "scale(1.1)" : "scale(1)",
                }}
              />
            </button>
          </div>

          {overview?.description && (
            <div className="detailps-overview-desc">{overview.description}</div>
          )}

          <div className="detailps-overview-list">
            {overview?.totalRaised?.amount && (
              <div
                className="flex justify-between"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span className="label">Total Raised:</span>
                <span className="value">{overview.totalRaised.amount}</span>
              </div>
            )}
            {overview?.preValuation?.amount && (
              <div
                className="flex justify-between"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span className="label">Pre-Valuation:</span>
                <span className="value">{overview.preValuation.amount}</span>
              </div>
            )}
            {category && (
              <div
                className="flex justify-between"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span className="label">Category:</span>
                <span className="value">{category}</span>
              </div>
            )}
            {overview?.lastUpdated?.lastupdatedtime && (
              <div
                className="flex justify-between"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span className="label">Last Updated:</span>
                <span className="value">
                  {overview.lastUpdated.lastupdatedtime}
                </span>
              </div>
            )}
          </div>

          <div className="detailps-overview-metrics">
            {overview?.marketCap && (
              <div>
                <span>Market Cap:</span>
                <div className="font-bold">{overview.marketCap}</div>
              </div>
            )}
            {overview?.fdv && (
              <div>
                <span>FDV:</span>
                <div className="font-bold">{overview.fdv}</div>
              </div>
            )}
            {overview?.volume && (
              <div>
                <span>Volume:</span>
                <div className="font-bold">{overview.volume}</div>
              </div>
            )}
          </div>

          {overview?.["Returns since last round"]?.length > 0 && (
            <div className="detailps-returns-section">
              <div className="detailps-returns-title">
                Returns since last round:
              </div>
              {overview["Returns since last round"].map((item, idx) => (
                <div key={idx} className="detailps-returns-row">
                  <span style={{ fontWeight: "bold" }}>{item.name}:</span>
                  <span>{item.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="detailps-activities-title">All Activities</div>
      <div className="detailps-activities-grid">
        {rounds &&
          rounds.map((round, idx) => (
            <div key={idx} className="detailps-activity-card">
              <div className="title">{round.roundTitle || "Round Title"}</div>
              <div className="item">
                Round Type: <span className="font-bold">{round.roundType}</span>
              </div>
              <div className="item">
                Round Date:{" "}
                <span className="font-bold">{round.rounddate || "N/A"}</span>
              </div>
              <div className="item">
                Price:{" "}
                <span className="font-bold">
                  {round.price && round.price !== "Unknown"
                    ? round.price
                    : "Not Provided"}
                </span>
              </div>
            </div>
          ))}
      </div>

      {/* Image Slider Modal */}
      {isSliderOpen && (
        <div className="detailps-slider-modal">
          <button className="detailps-slider-close" onClick={closeSlider}>
            <IoClose />
          </button>
          <div style={{ width: "85vw", maxWidth: "820px" }}>
            <Swiper initialSlide={currentImageIndex} navigation={true}>
              {images.map((img, idx) => (
                <SwiperSlide key={idx}>
                  <img
                    src={img}
                    alt={`Slide ${idx}`}
                    className="detailps-slider-mainimg"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailPS;
